var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("法律服务")]),
            _c("el-breadcrumb-item", [_vm._v("栏目与内容")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.dataLoading,
            expression: "dataLoading",
          },
        ],
        staticClass: "pageWrapper",
      },
      [
        _c(
          "div",
          { staticClass: "leftWrapper" },
          [
            _c(
              "el-card",
              { staticClass: "cardWrapper", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "title" }, [_vm._v("栏目列表")]),
                    _c(
                      "div",
                      { staticClass: "btns" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleRefresh()
                              },
                            },
                          },
                          [_vm._v("刷新")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAppend()
                              },
                            },
                          },
                          [_vm._v("添加顶级栏目")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c("el-tree", {
                  ref: "treeWrapperRef",
                  staticClass: "treeWrapper",
                  attrs: {
                    lazy: "",
                    "node-key": "id",
                    props: {
                      label: "name",
                      children: "children",
                      isLeaf: "isLeaf",
                    },
                    data: _vm.treeColumnData,
                    load: _vm.loadColumnData,
                    "expand-on-click-node": false,
                    "highlight-current": true,
                  },
                  on: { "node-click": _vm.handleNodeClick },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ data }) {
                        return _c(
                          "div",
                          { staticClass: "nodeWrapper" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(data.name)),
                            ]),
                            _c("el-button", {
                              attrs: {
                                circle: "",
                                size: "mini",
                                type: "success",
                                icon: "el-icon-plus",
                                title: "添加子栏目",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleAppend(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              attrs: {
                                circle: "",
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-edit",
                                title: "编辑栏目",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleEdit(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              attrs: {
                                circle: "",
                                size: "mini",
                                type: "danger",
                                icon: "el-icon-delete",
                                title: "删除栏目",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDelete(data)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mainWrapper" },
          [
            _vm.formVisible
              ? _c(
                  "el-card",
                  { staticClass: "cardWrapper", attrs: { shadow: "never" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("span", [_vm._v("栏目节点信息")]),
                    ]),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          model: _vm.formParams,
                          "label-width": "100px",
                          rules: _vm.checkListParams,
                        },
                      },
                      [
                        _vm.formParams.parentId
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "父级栏目：" } },
                              [_vm._v(_vm._s(_vm.formParams.parentName))]
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "栏目类型：" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.formParams.type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formParams, "type", $$v)
                                  },
                                  expression: "formParams.type",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 4 } }, [
                                  _vm._v("列表项一"),
                                ]),
                                _c("el-radio", { attrs: { label: 5 } }, [
                                  _vm._v("列表项二"),
                                ]),
                                _c("el-radio", { attrs: { label: 6 } }, [
                                  _vm._v("列表项三"),
                                ]),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("列表"),
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("电话"),
                                ]),
                                _c("el-radio", { attrs: { label: 3 } }, [
                                  _vm._v("内容项"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "栏目名称：" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入栏目名称",
                                maxlength: 100,
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.formParams.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formParams, "name", $$v)
                                },
                                expression: "formParams.name",
                              },
                            }),
                          ],
                          1
                        ),
                        [2, 3].includes(_vm.formParams.type)
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "栏目内容：" } },
                              [
                                _vm.formParams.type == 2
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入电话",
                                        maxlength: 20,
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: _vm.formParams.content,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formParams,
                                            "content",
                                            $$v
                                          )
                                        },
                                        expression: "formParams.content",
                                      },
                                    })
                                  : _vm.formParams.type == 3
                                  ? _c("RichTextarea", {
                                      staticClass: "wang-editor-style",
                                      attrs: { height: "300px" },
                                      model: {
                                        value: _vm.formParams.content,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formParams,
                                            "content",
                                            $$v
                                          )
                                        },
                                        expression: "formParams.content",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "栏目排序：" } },
                          [
                            _c("el-input-number", {
                              attrs: {
                                placeholder: "请输入栏目排序",
                                min: 0,
                                max: 9999,
                              },
                              model: {
                                value: _vm.formParams.sortNumber,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formParams, "sortNumber", $$v)
                                },
                                expression: "formParams.sortNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "栏目状态：" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 2,
                                "active-text": "上架",
                                "inactive-text": "下架",
                              },
                              model: {
                                value: _vm.formParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formParams, "status", $$v)
                                },
                                expression: "formParams.status",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.submitForm },
                              },
                              [_vm._v("确认保存")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }